<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img
        src="img/avatars/profile.png"
        class="img-avatar"
        alt="admin@bootstrapmaster.com" />
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>Account</strong><br><span>{{user.name}}</span></b-dropdown-header>
      <b-dropdown-item><i class="fa fa-wrench" /> Settings</b-dropdown-item>
      <b-dropdown-item @click="changePassword"><i class="fa fa-key" /> Change Password</b-dropdown-item>
      <b-dropdown-item @click="logMeOut"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import { mapState, mapActions } from 'vuex'
import { router } from '@/router'
//import { userService } from "@/resources/UserService.js";
export default {
  name: 'DefaultHeaderDropdown',
  components: {
    AppHeaderDropdown
  },
  computed: {
    ...mapState('account', ['user'])
  },
  methods: {
    ...mapActions('account', ['logout']),
    logMeOut() {
      this.logout();
    },
    changePassword() {
      router.push('/changePassword');
    }
  },
  created() {
    //console.log(this.user.username);
  }
  
}
</script>

